import type { SupabaseClient } from '@supabase/supabase-js';
import { getItemPriceHistory, getSpendingAnalytics } from '../../services/supabaseService';
import { queryClient, queryKeys } from './queryClient';

/**
 * Cached versions of per-user reads used outside React (store hydration,
 * CartAssistant tools). Concurrent calls share one request, and results
 * stay fresh for a minute; saving or deleting a trip invalidates them.
 */
export const fetchSpendingAnalytics = (
  supabase: SupabaseClient,
  userId: string,
  { fresh = false }: { fresh?: boolean } = {},
) =>
  queryClient.fetchQuery({
    queryKey: queryKeys.spendingAnalytics(userId),
    queryFn: () => getSpendingAnalytics(supabase, userId),
    staleTime: fresh ? 0 : 60 * 1000,
  });

export const fetchItemPriceHistory = (supabase: SupabaseClient, userId: string, slug: string) =>
  queryClient.fetchQuery({
    queryKey: queryKeys.itemPriceHistory(userId, slug),
    queryFn: () => getItemPriceHistory(supabase, userId, slug),
  });
